import gql from 'graphql-tag'

export const GET_SERVICE_TO_SERVICE_ORDERS = gql`
  query Service2ServiceOrders($filter: GetService2ServiceOrdersFilter!) {
    service2ServiceOrders(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      service2ServiceOrders {
        service2SoId
        serviceId
        serviceType
        serviceOrderId
        totalPrice
        service {
          name
          serviceAction {
            action
            serviceActionId
          }
          serviceActionId
          serviceCategory {
            name
            serviceCategoryId
          }
          serviceCategoryId
          serviceId
          totalService2Ssgroup
          totalServiceSchedule
        }
        serviceSchedule {
          vehicleId
          serviceId
          ssgroupId
          ssgroup {
            name
          }
          method
          startServiceAtDistance
          startServiceAtTime
          serviceTimeDifference {
            years
            months
            days
            hours
            minutes
            seconds
            milliseconds
            isDatePassed
            readableText
          }
          startServiceAtHourmeter
          serviceHourmeterDifference
          serviceDistanceDifference
          status
          type
        }
        part2Service {
          service2SoId
          partId
          qty
          price
          discount
          part {
            price
            name
          }
        }
      }
    }
  }
`

export const CREATE_SERVICE_TO_SERVICE_ORDER = gql`
  mutation CreateService2ServiceOrder($input: CreateService2ServiceOrderInput!) {
    createService2ServiceOrder(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createService2ServiceOrder {
        serviceOrderId
      }
    }
  }
`

export const BULK_CREATE_SERVICE_TO_SERVICE_ORDER = gql`
  mutation CreateServices2ServiceOrder($input: CreateServices2ServiceOrderInput!) {
    createServices2ServiceOrder(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createServices2ServiceOrder {
        serviceOrderId
      }
    }
  }
`

export const DELETE_SERVICE_TO_SERVICE_ORDER = gql`
  mutation DeleteService2ServiceOrder($input: DeleteService2ServiceOrderInput!) {
    deleteService2ServiceOrder(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`

export const BULK_CREATE_TO_SERVICE_ORDER = gql`
  mutation CreateServices2ServiceOrder($input: CreateServices2ServiceOrderInput!) {
    createServices2ServiceOrder(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      createServices2ServiceOrder {
        serviceId
        serviceOrderId
      }
    }
  }
`
